import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
//import {SearchBoxService} from "./searchBox.service";


@Component({
  selector: 'kv-searchbox',
  template: `    
    <div class="ui-g ui-fluid card card-w-title">
      <div class="ui-g-12" style="color: #20417b;font-size:18px;">
        {{'searchBox.search' | translate}}
      </div>
      <div class="ui-g-12">
        <div class="ui-g-9">
          <input pInputText [placeholder]="searchPlaceholder" type="text" 
                 [(ngModel)]="searchText" style="height: 40px;"
                 (keyup.enter)="this.onFind.emit(this.searchText);"/>
        </div>
        <div class="ui-g-3" >
          
          <button pButton type="button" class="k-generic-btn" label="{{'searchBox.find' | translate }}"
                  (click)="onFind.emit(searchText);"></button>
        </div>
      </div>
      <div class="ui-g-12" style="text-align: right;">
        <div class="ui-g-6"></div>
        <div class="ui-g-3">
          <button pButton type="button" class="k-generic-btn" label="{{'searchBox.find_advanced' | translate }}"
                  (click)="advancedSearch()"></button>
        </div>
        
      </div>
    </div>
  `,
  styles: [`
    .bugCalendar { overflow: visible !important; }

    .kvRoundedButton {
      width: 100%;
      height: 40px;
      border: none;
      background-color: #20417b !important;
      color: #ffffff !important;
      text-align: center;
      font-weight: 600;
      font-size: 14px;
      line-height: 1.11;
      border-radius: 100px;
    }

    .kvRoundedButton:hover {
      border: #20417b 1px solid !important;
      background-color: white !important;
      color: #20417b !important;
    }
  `]
})
export class SearchBoxComponent implements OnInit, OnChanges {

  constructor(/*private srvSearchBox: SearchBoxService*/
     ) {

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: any): void {
  }

  public searchText: string;


  @Input() searchPlaceholder: string;
  @Input() id: string = "SBOX_ID";
  //@Input() boxHeight: string = "auto";
  @Output() onFind: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAdvancedSearch: EventEmitter<any> = new EventEmitter<any>();

  advancedSearch() {
    this.onAdvancedSearch.emit();
    //this.srvSearchBox.get(this.id).showDetail = true;

  }

  onRapidSearch(event) {
    console.log(event);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/searchBox/searchBox.component.ts